import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { APP_VERSION } from "@/components/VersionGuard";

export default function Navbar() {
  const { user, impersonating, logout, stopImpersonation } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <>
      {impersonating && (
        <div className="sticky top-0 z-[60] bg-amber-500 text-black text-sm font-semibold px-6 py-2 flex items-center justify-center gap-4">
          <span>
            Impersonating <b>{user?.email}</b> (as {impersonating.email})
          </span>
          <button
            onClick={stopImpersonation}
            className="rounded-full bg-black/80 text-white px-4 py-1 text-xs font-bold hover:bg-black"
          >
            Stop impersonating
          </button>
        </div>
      )}
      <nav className="sticky top-0 z-50 border-b border-sky-500/30 bg-[#05080d]/90 backdrop-blur-lg">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-4 md:px-6 md:py-5">
          {/* Logo + build version */}
          <div className="flex min-w-0 items-center gap-2 md:gap-3">
            <Link to="/" className="flex min-w-0 items-center gap-3 md:gap-4">
              <img
                src="/logo.png"
                alt="Custom T Shirt Bar"
                className="h-10 w-10 shrink-0 rounded-lg md:h-[70px] md:w-[70px]"
              />
              <div className="min-w-0">
                <h1 className="truncate text-lg font-extrabold text-sky-400 sm:text-2xl md:whitespace-nowrap md:text-3xl">
                  CUSTOM T SHIRT BAR
                </h1>
                <p className="hidden text-xs text-gray-400 sm:block">DTF Printing • Custom Apparel</p>
                <p className="hidden text-xs text-gray-500 sm:block">Oudtshoorn • Fast Turnaround</p>
              </div>
            </Link>
            <span
              title="Site version"
              className="shrink-0 self-start rounded-full border border-sky-500/30 bg-sky-500/10 px-2 py-0.5 font-mono text-[10px] leading-none text-sky-300/90"
            >
              v{APP_VERSION}
            </span>
          </div>

          {/* Menu */}
          <div className="hidden items-center gap-6 font-medium text-white md:flex">
            <Link to="/" className="transition hover:text-sky-400">
              Home
            </Link>

            {user ? (
              <>
                <Link to="/studio" className="transition hover:text-sky-400">
                  Studio
                </Link>
                <Link to="/account" className="transition hover:text-sky-400">
                  My Account
                </Link>
                {user.role === "superadmin" && (
                  <Link to="/admin" className="font-bold text-amber-400 transition hover:text-amber-300">
                    Admin
                  </Link>
                )}
                <span className="text-gray-500 text-sm hidden lg:inline">{user.email}</span>
                <button
                  onClick={logout}
                  className="rounded-full border border-sky-500/40 px-5 py-2 font-semibold text-white transition hover:bg-sky-500/10"
                >
                  Log out
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="transition hover:text-sky-400">
                  Sign in
                </Link>
                <Link
                  to="/register"
                  className="rounded-full bg-sky-500 px-6 py-2.5 font-bold text-white transition-all duration-300 hover:scale-105 hover:bg-sky-400"
                >
                  Register
                </Link>
              </>
            )}
          </div>

          {/* Mobile toggle */}
          <button className="md:hidden text-white text-2xl" onClick={() => setOpen((v) => !v)}>
            ☰
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="md:hidden border-t border-sky-500/20 bg-[#05080d] px-6 py-4 flex flex-col gap-3 text-white">
            <Link to="/" onClick={() => setOpen(false)}>
              Home
            </Link>
            {user ? (
              <>
                <Link to="/studio" onClick={() => setOpen(false)}>
                  Studio
                </Link>
                <Link to="/account" onClick={() => setOpen(false)}>
                  My Account
                </Link>
                {user.role === "superadmin" && (
                  <Link to="/admin" className="text-amber-400 font-bold" onClick={() => setOpen(false)}>
                    Admin
                  </Link>
                )}
                <button onClick={logout} className="text-left text-gray-300">
                  Log out
                </button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)}>
                  Sign in
                </Link>
                <Link to="/register" className="text-sky-400 font-bold" onClick={() => setOpen(false)}>
                  Register
                </Link>
              </>
            )}
          </div>
        )}
      </nav>
    </>
  );
}
